import ReactDOM from 'react-dom';

import Index from './Home';

// ----------------------------------------------------------------------

ReactDOM.render(
      <Index />,
  document.getElementById('root')
);